import React, { useState, useEffect } from 'react';
import StartMenu from './StartMenu';
import { useWindows } from '../contexts/WindowContext';
import { Volume2, Wifi, Battery } from 'lucide-react';

// Add WindowData interface locally or import from context
interface WindowData {
  id: string;
  title: string;
  content: React.ReactNode;
  x: number;
  y: number;
  width: number;
  height: number;
  isMinimized: boolean;
  isMaximized: boolean;
  isActive: boolean;
  zIndex: number;
}

const Taskbar: React.FC = () => {
  const [showStartMenu, setShowStartMenu] = useState(false);
  const [currentTime, setCurrentTime] = useState(new Date());
  const { windows, focusWindow, minimizeWindow } = useWindows();

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentTime(new Date());
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  const formatTime = (date: Date) => {
    return date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
  };

  const formatDate = (date: Date) => {
    return date.toLocaleDateString([], { month: '2-digit', day: '2-digit', year: 'numeric' });
  };

  const handleTaskbarWindowClick = (window: WindowData) => {
    if (window.isMinimized) {
      // If window is minimized, restore it and focus it
      focusWindow(window.id);
    } else if (window.isActive) {
      // If window is active, minimize it
      minimizeWindow(window.id);
    } else {
      // If window is not active, focus it
      focusWindow(window.id);
    }
  };

  return (
    <>
      {showStartMenu && <StartMenu onClose={() => setShowStartMenu(false)} />}
      <div className="taskbar">
        <div className="taskbar-content">
          {/* Start Button */}
          <button
            className={`start-button ${showStartMenu ? 'pressed' : ''}`}
            onClick={() => setShowStartMenu(!showStartMenu)}
          >
            <div className="start-button-icon"></div>
            <span>start</span>
          </button>

          {/* Quick Launch */}
          <div className="quick-launch">
            <div className="taskbar-separator"></div>
          </div>

          {/* Running Applications */}
          <div className="taskbar-apps">
            {windows.map((window) => (
              <button
                key={window.id}
                className={`taskbar-app ${window.isActive && !window.isMinimized ? 'active' : ''}`}
                onClick={() => handleTaskbarWindowClick(window)}
              >
                <div className="taskbar-app-icon"></div>
                <span className="taskbar-app-title">{window.title}</span>
              </button>
            ))}
          </div>

          {/* System Tray */}
          <div className="system-tray">
            <div className="taskbar-separator"></div>
            <div className="tray-icons">
              <Volume2 size={16} className="tray-icon" />
              <Wifi size={16} className="tray-icon" />
              <Battery size={16} className="tray-icon" />
            </div>
            <div className="system-clock">
              <div className="time">{formatTime(currentTime)}</div>
              <div className="date">{formatDate(currentTime)}</div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Taskbar;